class Video {
    constructor(video) {
        this.video = video;
        this.overlay = video.querySelector(".youtube__content");
        this.dialog = video.querySelector(".youtube__consent_dialog");
        this.blur = video.querySelector(".youtube__blurfilter ");
        this.consentBox = video.querySelector(".checkbox");
        this.consentBox.input = video.querySelector("input");
        this.unlockButton = video.querySelector(".youtube__play_once");
        this.Iframe = video.querySelector("iframe");
    }
    lock() {
        this.dialog.removeAttribute("hidden");
        this.blur.classList.add("blur");
        if(getDimensionConsents().length == 0) {
            this.consentBox.classList.add("disabled");
            this.consentBox.input.disabled = true;
            this.consentBox.input.checked = false;
            this.consentBox.title = this.consentBox.dataset.title;
            return;
        }
        this.consentBox.classList.remove("disabled");
        this.consentBox.input.disabled = false;
        this.consentBox.input.checked = true;
        this.consentBox.title = "";
    }
    unlock() {
        this.dialog.setAttribute("hidden", true);
        this.blur.classList.remove("blur");
        this.Iframe.setAttribute("src",this.Iframe.dataset.src);
    }
    initPlayer() {
        new YT.Player(this.Iframe.id, {
            events: {
                "onReady": (event) => {
                    this.video.querySelector(".youtube__play").addEventListener("click", () => {
                        event.target.playVideo();
                        this.video.classList.add("youtube--show-video");
                    });
                }
            }
        });
    }
}

class GMap {
    constructor(map) {
        this.map = map;
        this.identifier = map.dataset.identifier;
        this.apiKey = map.dataset.apiKey;
        this.dialog = document.querySelector(".maps__consent_dialog[data-block=\""+this.identifier+"\"]");
        this.consentBox = this.dialog.querySelector(".checkbox");
        this.consentBox.input = this.dialog.querySelector("input");
        this.unlockButton = this.dialog.querySelector(".maps__play_once");
        this.contentBlocker = document.querySelector(".maps__content_blocker_wrapper[data-block=\""+this.identifier+"\"]");
    }
    lock() {
        this.dialog.removeAttribute("hidden");
        this.map.setAttribute("hidden", true);
        this.contentBlocker.removeAttribute("hidden");
        if(getDimensionConsents().length == 0) {
            this.consentBox.classList.add("disabled");
            this.consentBox.input.disabled = true;
            this.consentBox.input.checked = false;
            this.consentBox.title = this.consentBox.dataset.title;
            return;
        }
        this.consentBox.classList.remove("disabled");
        this.consentBox.input.disabled = false;
        this.consentBox.input.checked = true;
        this.consentBox.title = "";
    }
    unlock() {
        this.dialog.setAttribute("hidden", true);
        this.map.removeAttribute("hidden");
        this.contentBlocker.setAttribute("hidden",true);
    }
}

const initYoutubeState = () => {
    const consentId = "youtube";
    let videos = document.querySelectorAll(".youtube");
    let videoObjects = [];
    videos.forEach( (video) => {
        videoObjects.push(new Video(video));
    });
    if (document.body.classList.contains("neos-backend")) {
        return unlockAllVideos(videoObjects);
    }
    if (proofConsent(consentId)){
        return unlockAllVideos(videoObjects);
    }
    videoObjects.forEach((video)=>{
        video.unlockButton.addEventListener("click", () => {
            if (video.consentBox.input.checked == false) {
                unlockOneVideo(video);
            }
            if (video.consentBox.input.checked == true) {
                saveConsentToCookie([consentId,"media"]);
                initYoutubeState();
            }
        });
        video.lock();
    });
};

const unlockOneVideo = (video) => {
    if(document.querySelectorAll("script[src='https://www.youtube.com/iframe_api']").length) {
        video.unlock();
        if (YT) {
            video.initPlayer();
        }
        return;
    }
    let tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    let firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    window.onYouTubeIframeAPIReady = function() {
        video.unlock();

        video.initPlayer();
    };
};

const unlockAllVideos = (videoObjects) => {
    if ( typeof YT == "object") {
        videoObjects.forEach((video) => {
            video.unlock();
            video.initPlayer();
        });
        return;
    }
    if(document.querySelectorAll("script[src='https://www.youtube.com/iframe_api']").length == 0) {
        let tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        let firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    window.onYouTubeIframeAPIReady = function() {
        videoObjects.forEach((video) => {
            video.unlock();
            video.initPlayer();
        });
    };
};

const proofConsent = (name) => getDimensionConsents().includes(name);
const saveConsentToCookie = (names) => {
    const cookie = getCookieByName("; "+ KD_GDPR_CC.cookieName +"=");
    const currentDate = new Date();
    let expireDate;

    if (KD_GDPR_CC.decisionTtl && KD_GDPR_CC.decisionTtl > 0) {
        expireDate = new Date(currentDate.getTime() + KD_GDPR_CC.decisionTtl);
    } else {
        expireDate = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate());
    }

    let consents = cookie && cookie.consents ? cookie.consents : {};

    names.forEach(function (name) {
        consents[KD_GDPR_CC.dimensionsIdentifier].includes(name) ? null : consents[KD_GDPR_CC.dimensionsIdentifier].push(name);
    });

    let consentDates = cookie && cookie.consentDates ? cookie.consentDates : {};
    consentDates[KD_GDPR_CC.dimensionsIdentifier] = currentDate.toUTCString();

    const cookieData = {
        consents: consents,
        consentDates: consentDates,
        consentDate: currentDate.toUTCString(),
        expireDate: expireDate.toUTCString()
    };

    const cookieParams = encodeURI(JSON.stringify(cookieData)) + "; expires=" + new Date(currentDate.getTime() + 315360000000).toUTCString() + "; path=/; " + (KD_GDPR_CC.cookieDomainName ? ("domain=" + KD_GDPR_CC.cookieDomainName + ";") : "") + (location.protocol.substring(0,5) === "https" ? " Secure;" : "");
    document.cookie = KD_GDPR_CC.cookieName + "=" + cookieParams;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "KD_GDPR_CC_consent",
        KD_GDPR_CC: {
            consents: cookieData.consents
        }
    });
};
const getDimensionConsents = () => {
    const cookie = getCookieByName("; "+ KD_GDPR_CC.cookieName +"=");
    const consents = cookie && cookie.consents ? cookie.consents : [];
    return consents[KD_GDPR_CC.dimensionsIdentifier] ? consents[KD_GDPR_CC.dimensionsIdentifier] : [];
};
const getCookieByName = (cookieName) => {
    const value = "; " + document.cookie;
    const parts = value.split(cookieName);
    if (parts.length === 2) {
        const cookieValue = parts.pop().split(";").shift();
        return JSON.parse(decodeURI(cookieValue));
    }
};
function refreshConsents() {
    setTimeout(() => {initYoutubeState(); initMapState();}, 10);
}

const initMapState = () => {
    const consentId = "googlemaps";
    let maps = [];
    let mapDivs = document.querySelectorAll(".jonnitto-googlemaps-mapview");
    mapDivs.forEach((map)=>{
        maps.push(new GMap(map));
    });
    if (document.body.classList.contains("neos-backend")) {
        return unlockAllMaps(maps);
    }
    if (proofConsent(consentId)){
        return unlockAllMaps(maps);
    }
    maps.forEach((map)=>{
        map.unlockButton.addEventListener("click", () => {
            if (map.consentBox.input.checked    ) {
                saveConsentToCookie([consentId,"media"]);
                initMapState();
            }
            if (!map.consentBox.input.checked) {
                unlockOneMap(map);
            }
        });
        map.lock();
    });
};
const unlockOneMap = (map) => {
    if(map) {
        if (!document.querySelectorAll("script[src^='https://maps.google.com/maps/api/js']").length) {
            let tag = document.createElement("script");
            tag.src = "https://maps.google.com/maps/api/js?callback=initJonnittoGoogleMaps&key=" + map.apiKey;
            let firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
        map.unlock();
    }
};
const unlockAllMaps = (maps) => {
    if(maps.length) {
        if (!document.querySelectorAll("script[src^='https://maps.google.com/maps/api/js']").length) {
            let tag = document.createElement("script");
            tag.src = "https://maps.google.com/maps/api/js?callback=initJonnittoGoogleMaps&key=" + maps[0].apiKey;
            let firstScriptTag = document.getElementsByTagName("script")[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
        maps.forEach((map) => {
            map.unlock();
        });
    }
};
initMapState();
initYoutubeState();
window.refreshConsents = refreshConsents;
if (document.body.classList.contains("neos-backend")) {
    document.addEventListener("Neos.NodeCreated", function () {
        initYoutubeState();
    });
}
